(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  /* SCRIPT BACK TO TOP */

  (function(){
    const footer = document.getElementById("footer")
                || document.getElementById("shopify-section-footer")
                || document.querySelector("footer");

    // L’ancre du bouton pour empêcher le scroll au clic
    const btn = document.querySelector(".back-to-top");

    // Les 3 wrappers contenant chacun le SVG rendu par le snippet
    const svg1 = document.getElementById("back-top-1");
    const svg2 = document.getElementById("back-top-2");
    const svg3 = document.getElementById("back-top-3");

    function showOnly(el) {
      [svg1, svg2, svg3].forEach(n => n && n.classList.add("hidden"));
      el && el.classList.remove("hidden");
    }

    if (!footer || !svg1 || !svg2 || !svg3) {
      console.warn("[back-top] Élément introuvable", { footer, svg1, svg2, svg3 });
      return;
    }

    // Empêche tout scroll dû au clic sur l’ancre (#)
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    }

    // État
    let inFooter = false;              // footer visible ?
    let scrolledWhileInFooter = false; // a-t-on bougé depuis l’entrée ?

    function footerVisible() {
      const r = footer.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    // --------- INIT: calcule l’état réel au chargement ---------
    (function init(){
      if (footerVisible()) {
        inFooter = true;
        scrolledWhileInFooter = false;
        showOnly(svg1); // état initial dans le footer
      } else {
        inFooter = false;
        showOnly(svg3); // hors footer
      }
    })();

    // --------- IO: détecte entrée/sortie du footer ---------
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver((entries) => {
        const e = entries[0];
        if (e && e.isIntersecting) {
          inFooter = true;
          scrolledWhileInFooter = false;
          showOnly(svg1); // retour à l’état initial en entrant
        } else {
          inFooter = false;
          showOnly(svg3); // hors footer
        }
      }, { threshold: 0 });
      io.observe(footer);
    } else {
      // Fallback si IO indispo
      function compute() {
        const vis = footerVisible();
        if (vis && !inFooter) {
          inFooter = true; scrolledWhileInFooter = false; showOnly(svg1);
        } else if (!vis && inFooter) {
          inFooter = false; showOnly(svg3);
        }
      }
      window.addEventListener("scroll", compute, { passive: true });
      window.addEventListener("resize", compute);
    }

    // --------- Passage à l’icône 2 : dès qu’on BOUGE dans le footer ---------
    // (On n’initie JAMAIS de scroll, on observe seulement le scroll utilisateur.)
    let ticking = false;
    function onScroll(){
      if (!ticking) {
        requestAnimationFrame(() => {
          if (inFooter && !scrolledWhileInFooter && footerVisible()) {
            scrolledWhileInFooter = true;
            showOnly(svg2); // a commencé à scroller tout en restant dans le footer
          }
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });

    // Recalibre sur resize (utile si footer arrive dans le viewport)
    window.addEventListener("resize", () => {
      const vis = footerVisible();
      if (vis) {
        if (!inFooter) { inFooter = true; scrolledWhileInFooter = false; showOnly(svg1); }
      } else {
        if (inFooter) { inFooter = false; showOnly(svg3); }
      }
    });
  })();

  document.querySelectorAll('.footer-menu__show-more-link').forEach((toggle) => {
    toggle.addEventListener('click', (event) => {
      event.preventDefault();

      const panel = toggle.closest('.disclosure__content');
      if (!panel) return;

      const extraLinks = panel.querySelectorAll('.footer-menu__extra-link');
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (!isExpanded) {
        extraLinks.forEach((item) => item.classList.remove('hidden'));
        toggle.setAttribute('aria-expanded', 'true');
        toggle.querySelector('.footer-menu__show-more-text').textContent = 'Afficher moins';
      } else {
        extraLinks.forEach((item) => item.classList.add('hidden'));
        toggle.setAttribute('aria-expanded', 'false');
        toggle.querySelector('.footer-menu__show-more-text').textContent = 'Afficher plus';
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-default"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
